/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { Box, Button } from "@material-ui/core";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

import type { ProductData } from "@spwn/types/firebase/firestore";
import type { FC, SVGAttributes } from "react";

export const LiveCommercePurchaseBar: FC<{
  isDrawerOpen: boolean;
  isDisabled: boolean;
  inCartNum: number;
  pseudoCart: (ProductData & { count: number })[];
  buttonText: string;
  onClickButton: () => void;
  onClickDrawerOpen: () => void;
}> = ({
  isDrawerOpen,
  isDisabled,
  inCartNum,
  pseudoCart,
  buttonText,
  onClickButton,
  onClickDrawerOpen,
}) => {
  const { t } = useI18n();

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      padding={"12px 16px"}
      bgcolor={"#F0F0F0"}
    >
      <Box
        display={"flex"}
        alignItems={"center"}
        gridGap={"4px"}
        onClick={pseudoCart.length > 0 ? onClickDrawerOpen : undefined}
        style={{
          ...(pseudoCart.length > 0 && { cursor: "pointer" }),
        }}
      >
        <Box paddingTop={"4px"} fontSize={"14px"} fontWeight={"700"}>
          {t("streaming.commerceGoodsList.cart", {
            itemNum: inCartNum,
          })}
        </Box>

        {pseudoCart.length > 0 && (
          <ArrowIcon
            style={{
              width: "24px",
              height: "auto",
              transform: isDrawerOpen ? "rotate(0deg)" : "rotate(180deg)",
              transition: "transform 0.3s ease",
            }}
          />
        )}
      </Box>

      <Button
        component={"button"}
        onClick={onClickButton}
        disabled={isDisabled}
        style={{
          padding: "6px 16px",
          color: "#fff",
          fontSize: "14px",
          fontWeight: "bold",
          textAlign: "center",
          backgroundColor: "#000",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
        }}
        css={css`
          &:disabled {
            background-color: #a3a3a3 !important;
            cursor: not-allowed !important;
          }
        `}
      >
        {buttonText}
      </Button>
    </Box>
  );
};

const ArrowIcon: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
        fill="black"
      />
    </svg>
  );
};
